import { Vector } from './Vector';
import { pipe } from 'fp-ts/lib/pipeable';
import { fold } from 'fp-ts/lib/Either';
/**
 * a {@link Vector} constrained to a dimensionality of 2
 */
export class Vector2D {
    _vec;
    static fromPosition = (p) => new Vector2D(p.value());
    constructor(initialContents) {
        this._vec = new Vector(2, initialContents);
    }
    dimensionality() {
        return this._vec.dimensionality();
    }
    value() {
        return this._vec.value();
    }
    dot(right) {
        return this._vec.dot(right);
    }
    scale(scalar) {
        return new Vector2D(this._vec.scale(scalar).value());
    }
    sum(right) {
        return pipe(this._vec.sum(right), fold((error) => {
            throw new Error(error);
        }, (vec) => new Vector2D(vec.value())));
    }
    sub(right) {
        return pipe(this._vec.sub(right), fold((error) => {
            throw new Error(error);
        }, (vec) => new Vector2D(vec.value())));
    }
    normalise() {
        return new Vector2D(this._vec.normalise().value());
    }
    cross(right) {
        throw new Error('Cannot perform cross on a Vector 2D, wrong dimensionality (2 when it should be at least 3): ' +
            right);
    }
    neg() {
        return new Vector2D(this._vec.neg().value());
    }
    mag() {
        return this._vec.mag();
    }
    toString() {
        const [l, r] = this._vec.value();
        return `Vector2D( ${l}, ${r} )`;
    }
}
//# sourceMappingURL=Vector2D.js.map